var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hero",style:({ 'background-image': ("url(" + (_vm.getHeroBackgroundImage()) + ")") })},[_c('h1',{staticClass:"hero-title hero-header",domProps:{"innerHTML":_vm._s(this.$sanitize(_vm.heroTextContent))}})])}
var staticRenderFns = []

export { render, staticRenderFns }